export default __webpack_public_path__ + "static/media/vid1.57456d66.mp4";